import React from 'react';

function BlankPage() {

    return <p/>;
}

export default BlankPage;